import { Link } from 'react-router-dom';
import { useI18n } from '../i18n';
import { BrandWordmark } from './BrandLogo';

/**
 * FooterMini — compact dark footer used on every page EXCEPT the home page.
 *
 * Why dark? The BrandWordmark uses `text-zinc-50` for the "Maker" word and a
 * light/cyan accent for "Cutt" — on the previous light-zinc footer the
 * wordmark was almost invisible. A dark band (zinc-950) lets the logo pop.
 *
 * Why compact? Tools, admin and account pages don't need the full link
 * directory; that lives on the home page. Here we only keep the bottom
 * lockup: brand on the left, copyright on the right.
 */
export default function FooterMini() {
  const { t } = useI18n();
  return (
    <footer className="mt-auto bg-zinc-950 border-t border-zinc-900">
      <div className="max-w-[1600px] mx-auto px-3 sm:px-5 py-3 sm:py-4">
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <Link
            to="/"
            className="hover:opacity-80 transition-opacity"
            aria-label="MakerCutt — home"
          >
            <BrandWordmark />
          </Link>
          <span className="text-zinc-500 text-[10px] sm:text-[11px] font-mono uppercase tracking-[0.18em]">
            {t('copyright')}
          </span>
        </div>
      </div>
    </footer>
  );
}
